import { EmailDto } from '@dhl/mdp-api'
import type { Email } from '~/common/model/emails'
export const convertToEmail = ({ address }: EmailDto): Email => address
